<template>
	<div class="settings">
		<div class="settings--title">
			{{ transUcfirst('commons.settings') }}
		</div>
		<div class="settings-content">
			<TagGroupsList
				v-if="showHome"
				:selected="selectedTagGroup"
				:class="'size-full'"
				:can-create="false"
				:can-edit="false"
				@change="onTagGroupSelected"
			/>
		</div>
	</div>
</template>

<script>
import TagGroupsList from '@videotools/js/one/components/TagGroups/TagGroupsList';
import { mapActions, mapGetters } from 'vuex';

export default {
	name:       'SettingsPageMobile',
	components: { TagGroupsList },
	data() {
		return {
			showCreate:     false,
			showEdit:       false,
			editedTagGroup: null,
		};
	},
	computed: {
		...mapGetters({
			tagGroups:        'tagGroups/tagGroups',
			selectedTagGroup: 'tagGroups/selectedTagGroup',
		}),
		showHome() {
			return !this.showCreate && !this.showEdit;
		},
	},
	mounted() {
		this.fetchTagGroups().then(() => this.selectDefaultIfNone());
	},
	methods: {
		...mapActions({
			fetchTagGroups: 'tagGroups/fetchTagGroups',
			setSelected:    'tagGroups/setSelected',
		}),
		onTagGroupSelected(tagGroup) {
			this.setSelected(tagGroup);
		},
		selectDefaultIfNone() {
			if (!this.selectedTagGroup) {
				this.setSelected(this.tagGroups.find(tg => tg.isDefault));
			}
		},
		closeEdit() {
			this.showEdit = false;
			this.editedTagGroup = null;
		},
	},
};
</script>

<style lang="scss">
@import "@videotools/sass/settings";
</style>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.settings {
	width: 100%;
	height: 100%;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	background: var(--color-black);
	color: var(--color-soft-white);

	> div {
		flex: 1;
	}

	.settings--title {
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 12px 16px;
		flex-grow: 0;
		border-bottom: 1px solid var(--color-grey-800);
	}

	&-content {
		display: flex;
		overflow-x: hidden;
		overflow-y: auto;
	}

	::v-deep {
		.settings-content {
			.settings-column {
				flex: 1;
				flex-basis: 100%;
				background: var(--color-grey-900);

				.header {
					padding: 16px 16px 8px 16px;
				}

				.body {
					padding: 16px;
				}

				&--title {
					p {
						padding-top: 8px;
					}
				}
			}

			.tag-groups {
				overflow: initial;

				.tag-group {
					background: var(--color-grey-950);
				}
			}
		}
	}
}

</style>
